<microsec-loading-overlay [isLoading]="isLoading">
  <div class="grid grid-cols-12 gap-4">
    <!-- Unacted/Open Recommendation -->
    <ng-template
      [ngTemplateOutlet]="mitigationViewTemplate"
      [ngTemplateOutletContext]="{ mitigations: unactedMitigations, status: MITIGATION_STATUSES.UNACTED }"></ng-template>
    <!-- Acted/Active/Completed Recommendation -->
    <ng-template
      [ngTemplateOutlet]="mitigationViewTemplate"
      [ngTemplateOutletContext]="{ mitigations: actedMitigations, status: MITIGATION_STATUSES.ACTED }"></ng-template>
  </div>
</microsec-loading-overlay>

<!-- Recommendation Dataview Template -->
<ng-template #mitigationViewTemplate let-mitigations="mitigations" let-status="status" let-first="first">
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <label class="col-span-12 font-bold">{{ (status | constant: 'threat-mitigation-status') + ' Recommendations' }} </label>
      <div class="col-span-12">
        <microsec-common-toolbar
          #ct
          [configuration]="
            status === MITIGATION_STATUSES.UNACTED
              ? filterUnactedConfiguration
              : status === MITIGATION_STATUSES.ACTED
                ? filterActedConfiguration
                : null
          "
          [filterObject]="
            status === MITIGATION_STATUSES.UNACTED ? filterUnactedObject : status === MITIGATION_STATUSES.ACTED ? filterActedObject : $any(null)
          "
          [leftTemplate]="
            status === MITIGATION_STATUSES.UNACTED && !!threat?.threat_id && !!permissions[USER_ROLE.TECHNICIAN] ? leftTemplate : null
          " />
        <ng-template #leftTemplate>
          <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
            <p-button
              label="Create Recommendation"
              severity="primary"
              [rounded]="true"
              icon="pi pi-plus"
              [disabled]="!isValidLicense()"
              (onClick)="openMitigationForm()" />
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  @if (mitigations.length > 0) {
    <!-- When Recommendation is NOT empty -->
    <div class="col-span-12">
      <p-dataView
        #dv
        styleClass="microsec-dashboard-dataView"
        [value]="mitigations"
        [loading]="isLoading"
        [rows]="PER_PAGE"
        [paginator]="true"
        [rowsPerPageOptions]="PER_PAGE_OPTIONS">
        <ng-template #list let-mitigations>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              @for (m of mitigations; track $index; let first = $first) {
                <div class="mb-4 border-0 w-full">
                  <microsec-card [isNestedCard]="true" [isBordered]="true">
                    <div class="flex flex-row p-1">
                      <i class="fa-2x fa-solid fa-shield-halved"></i>
                      <div class="flex flex-col pl-4">
                        <label class="font-bold"> {{ m.title || 'Recommendation' }} </label>
                        <label class="text-grey mt-1 mb-4"> {{ m.description || '' }} </label>
                        <div class="flex flex-row items-center mitigation-recommend-button">
                          <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                            <p-select
                              (click)="$event.stopPropagation()"
                              [(ngModel)]="m.status"
                              [options]="statusOptions"
                              optionLabel="label"
                              optionValue="value"
                              appendTo="body"
                              (onChange)="updateMitigationStatus($event, m)"
                              [disabled]="!permissions[USER_ROLE.TECHNICIAN] || !!m.is_imported || !isValidLicense()" />
                          </span>
                          @if (!!permissions[USER_ROLE.TECHNICIAN]) {
                            <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                              <p-button
                                [disabled]="!!m.is_imported || !isValidLicense()"
                                class="mr-2 ml-2"
                                styleClass="edit-button"
                                label="Edit"
                                severity="primary"
                                (onClick)="openMitigationForm(m)" />
                            </span>
                          }
                          @if (!!permissions[USER_ROLE.ADMIN]) {
                            <p-button
                              [disabled]="!!m.is_imported"
                              styleClass="delete-button"
                              label="Delete"
                              severity="primary"
                              (onClick)="openDeleteConfirmation(m)" />
                          }
                        </div>
                      </div>
                    </div>
                  </microsec-card>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  } @else {
    <!-- When Recommendation is empty -->
    <div class="col-span-12 mb-4 mt-4">
      <p class="text-grey text-center">No Recommendations</p>
    </div>
  }
</ng-template>
